module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "iadapter"
  }, [_c('navbar', {
    attrs: {
      "transparent": _vm.isTransparent
    }
  }), _vm._v(" "), _c('section', {
    staticClass: "iadapter-banner"
  }, [_c('div', {
    staticClass: "iadapter-banner-tile"
  }, [_c('h1', [_vm._v(_vm._s(_vm.$t('iadapter_banner_tittle')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('iadapter_banner_content')))])])]), _vm._v(" "), _c('section', [_c('row', {
    staticClass: "max_width iAdapter_buy_page"
  }, [_c('i-col', {
    attrs: {
      "lg": 12,
      "md": 12,
      "sm": 24,
      "xs": 24
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/store/iadapter/iAdapter_1.png"),
      "width": "90%"
    }
  })]), _vm._v(" "), _c('i-col', {
    staticClass: "iAdapter_buy_page2",
    attrs: {
      "lg": 12,
      "md": 12,
      "sm": 24,
      "xs": 24
    }
  }, [_c('h1', [_vm._v(_vm._s(_vm.$t('iadapter_buy_tittle')))]), _vm._v(" "), _c('span', [_vm._v("$" + _vm._s(_vm.goods_info.goods_price))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('iadapter_buy_content')))]), _vm._v(" "), _c('buy', {
    attrs: {
      "id": parseInt(_vm.$route.query.id),
      "maxCount": parseInt(_vm.goods_info.store_count)
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('section', [_c('row', {
    staticClass: "max_width iAdapter_detail_1"
  }, [_c('i-col', {
    attrs: {
      "span": 24
    }
  }, [_c('h1', [_vm._v(_vm._s(_vm.$t('iadapter_detail_advantage')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('iadapter_detail_advantage_content')))]), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../../../assets/store/iadapter/iadapter_4.png"),
      "width": "90%"
    }
  })])], 1)], 1), _vm._v(" "), _c('section', {
    staticStyle: {
      "background-image": "linear-gradient(44deg, #E7E8E9 0%, #FAFBFB 72%, #FDFDFD 82%, #FFFFFF 100%)"
    }
  }, [_c('row', {
    staticClass: "max_width iAdapter_detail_1"
  }, [_c('i-col', {
    attrs: {
      "span": 24
    }
  }, [_c('h1', [_vm._v(_vm._s(_vm.$t('iadapter_detail_advantage2')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('iadapter_detail_advantage_content2')))]), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../../../assets/store/iadapter/iadapter_5.png"),
      "width": "90%"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "iAdapter_detail_1_foot"
  }, [_vm._v("\n                    " + _vm._s(_vm.$t('iadapter_detail_advantage_content2-1'))), _c('br'), _vm._v(_vm._s(_vm.$t('iadapter_detail_advantage_content2-2')) + "\n                ")])])], 1)], 1), _vm._v(" "), _c('section', [_c('row', {
    staticClass: "max_width iAdapter_detail_1"
  }, [_c('i-col', {
    attrs: {
      "span": 24
    }
  }, [_c('h1', [_vm._v(_vm._s(_vm.$t('iadapter_detail_advantage3')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('iadapter_detail_advantage_content3')))]), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../../../assets/store/iadapter/iadapter_6.png"),
      "width": "90%"
    }
  })])], 1)], 1), _vm._v(" "), _c('section', {
    staticStyle: {
      "background-image": "linear-gradient(44deg, #E7E8E9 0%, #FAFBFB 72%, #FDFDFD 82%, #FFFFFF 100%)"
    }
  }, [_c('row', {
    staticClass: "max_width iAdapter_detail_1"
  }, [_c('i-col', {
    attrs: {
      "span": 24
    }
  }, [_c('h1', [_vm._v(_vm._s(_vm.$t('iadapter_detail_advantage4')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('iadapter_detail_advantage_content4-1')) + "\n                    "), _c('br'), _vm._v(_vm._s(_vm.$t('iadapter_detail_advantage_content4-2')))]), _vm._v(" "), _c('img', {
    staticStyle: {
      "width": "550px",
      "max-width": "90%"
    },
    attrs: {
      "src": require("../../../assets/store/iadapter/iadapter_7.png"),
      "width": "90%"
    }
  })])], 1)], 1), _vm._v(" "), _c('section', [_c('row', {
    staticClass: "max_width iAdapter_detail_1"
  }, [_c('i-col', {
    attrs: {
      "span": 24
    }
  }, [_c('h1', [_vm._v(_vm._s(_vm.$t('iadapter_detail_advantage5')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('iadapter_detail_advantage_content5-1')))]), _vm._v(" "), (_vm.type === 'a') ? _c('img', {
    staticStyle: {
      "width": "100%",
      "max-width": "95%"
    },
    attrs: {
      "src": require("../../../assets/store/iadapter/iadapter_8.png"),
      "width": "95%"
    }
  }) : (_vm.type === 'b') ? _c('img', {
    staticStyle: {
      "width": "100%",
      "max-width": "95%"
    },
    attrs: {
      "src": require("../../../assets/store/iadapter/iadapter_8_en.png"),
      "width": "95%"
    }
  }) : (_vm.type === 'c') ? _c('img', {
    staticStyle: {
      "width": "100%",
      "max-width": "95%"
    },
    attrs: {
      "src": require("../../../assets/store/iadapter/iadapter_8_fanti.png"),
      "width": "95%"
    }
  }) : _vm._e()])], 1)], 1), _vm._v(" "), _c('section', {
    attrs: {
      "id": "iAdapter_detail"
    }
  }, [_c('row', {
    staticClass: "max_width iAdapter_detail_1"
  }, [_c('i-col', {
    attrs: {
      "span": 24
    }
  }, [_c('h1', {
    staticStyle: {
      "color": "white"
    }
  }, [_vm._v(_vm._s(_vm.$t('iadapter_detail_advantage6')))]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "white"
    }
  }, [_vm._v(_vm._s(_vm.$t('iadapter_detail_advantage_content6-1')))])])], 1)], 1), _vm._v(" "), _c('section', {
    staticStyle: {
      "background-image": "linear-gradient(44deg, #E7E8E9 0%, #FAFBFB 72%, #FDFDFD 82%, #FFFFFF 100%)"
    }
  }, [_c('row', {
    staticClass: "iAdapter_detail",
    staticStyle: {
      "max-width": "700px",
      "margin": "0 auto"
    }
  }, [_c('i-col', {
    attrs: {
      "lg": 12,
      "md": 12,
      "sm": 24,
      "xs": 24
    }
  }, [_c('div', {
    staticClass: "iAdapter_detail_group"
  }, [_c('ul', [_c('li', {
    staticClass: "detail_title"
  }, [_vm._v(_vm._s(_vm.$t('details_page_product_parameters')))]), _vm._v(" "), _c('li', {
    staticClass: "detail_dec"
  }, [_vm._v(_vm._s(_vm.$t('iadapter_detail_1')))]), _vm._v(" "), _c('li', {
    staticClass: "detail_dec"
  }, [_vm._v(_vm._s(_vm.$t('iadapter_detail_2')))]), _vm._v(" "), _c('li', {
    staticClass: "detail_dec"
  }, [_vm._v(_vm._s(_vm.$t('iadapter_detail_3')))]), _vm._v(" "), _c('li', {
    staticClass: "detail_dec"
  }, [_vm._v(_vm._s(_vm.$t('iadapter_detail_4')))]), _vm._v(" "), _c('li', {
    staticClass: "detail_dec"
  }, [_vm._v(_vm._s(_vm.$t('iadapter_detail_5')))]), _vm._v(" "), _c('li', {
    staticClass: "detail_dec"
  }, [_vm._v(_vm._s(_vm.$t('iadapter_detail_6')))]), _vm._v(" "), _c('li', {
    staticClass: "detail_dec"
  }, [_vm._v(_vm._s(_vm.$t('iadapter_detail_7')))]), _vm._v(" "), _c('li', {
    staticClass: "detail_dec"
  }, [_vm._v(_vm._s(_vm.$t('iadapter_detail_8')))]), _vm._v(" "), _c('li', {
    staticClass: "detail_dec"
  }, [_vm._v(_vm._s(_vm.$t('iadapter_detail_9')))])])])]), _vm._v(" "), _c('i-col', {
    staticClass: "iAdapter_buy_page2",
    attrs: {
      "lg": 12,
      "md": 12,
      "sm": 24,
      "xs": 24
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/store/iadapter/iadapter_3.png"),
      "width": "70%"
    }
  })])], 1)], 1), _vm._v(" "), _c('section', {
    staticStyle: {
      "max-width": "1200px",
      "margin": "0 auto",
      "text-align": "left",
      "width": "100%",
      "padding": "30px 10px",
      "font-size": "16px",
      "color": "#5E6D82"
    }
  }, [_c('p', {
    staticStyle: {
      "color": "#0084ff"
    }
  }, [_vm._v(_vm._s(_vm.$t('shopping_notes')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('shopping_notes_tip')))]), _vm._v(" "), _c('guess')], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a6ecd1f6","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ProductDetails/iGO/iAdapter.vue
// module id = 840
// module chunks = 0